import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.space',
    'resource:data.dimensions.space.attributes.sqft',
    'resource:data.dimensions.space.entities.room',
    'resource:data.dimensions.space.entities.room.attributes.spaceUse',
    'resource:data.dimensions.space.entities.room.attributes.hegisCode',
    'resource:data.dimensions.space.entities.floor',
    'resource:data.dimensions.space.entities.campus',
    'resource:data.dimensions.space.entities.building',
    'resource:data.dimensions.spaceUse',
    'resource:data.dimensions.spaceUse.entities.roomGroup',
    'resource:data.dimensions.spaceUse.entities.roomType',
  ],
  description: 'TODO',
  name: 'Data - Space',
} as const satisfies core.quiver.Package
